import script from "./VisitCompatibilityMatrix.vue?vue&type=script&setup=true&lang=ts"
export * from "./VisitCompatibilityMatrix.vue?vue&type=script&setup=true&lang=ts"

import "./VisitCompatibilityMatrix.vue?vue&type=style&index=0&id=561ed30d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-561ed30d"]])

export default __exports__